// File: src/components/contact/HubSpotMeetings.js

import React, { useEffect } from 'react';
import styles from './HubSpotMeetings.module.css';
import ScrollAnimation from '../common/ScrollAnimation';

function HubSpotMeetings() {
  useEffect(() => {
    const SCRIPT_SRC =
      'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';

    // Remove any existing script so HubSpot re-scans the DOM on re-mount
    const existingScript = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup on unmount — keeps things tidy between navigations
    return () => {
      const s = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
      if (s) s.remove();
    };
  }, []); // Empty array — runs on every mount/unmount cycle

  return (
    <section className={styles.section}>
      <div className="site-container">
        <ScrollAnimation>
          <div className={styles.header}>
            <span className={styles.badge}>Book a Meeting</span>
            <h2 className={styles.heading}>Schedule a Call</h2>
            <p className={styles.description}>
              Ready to talk? Book a time directly with our team.
            </p>
          </div>
          <div className={styles.embedWrapper}>
            <div
              className="meetings-iframe-container"
              data-src="https://meetings-na3.hubspot.com/thomas-christiansen?embed=true"
            />
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}

export default HubSpotMeetings;